import { render } from "./invoice-record.vue?vue&type=template&id=8bfd5c14&scoped=true&ts=true"
import script from "./invoice-record.vue?vue&type=script&lang=ts"
export * from "./invoice-record.vue?vue&type=script&lang=ts"

import "./invoice-record.vue?vue&type=style&index=0&id=8bfd5c14&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bfd5c14"]])

export default __exports__